import React,  { useEffect } from "react";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

import "./App.scss";
import Configure from "./components/Configure/Configure.js";
import BillofMaterials from "./components/Bom/Bom.js";

import Button from "@material-ui/core/Button";
import { NONAME } from "dns";

import { Provider as ReduxProvider } from "react-redux";
import configureStore from "./store/store";

import ACTIONS from "./actions/action";
import { connect } from "react-redux";

function App(props) {
  const { localeSettings } = props;

  //Get locale settings/strings
  useEffect(() => localeSettings(), []);

  return (
    <ThemeProvider theme={theme}>
      
      <div className="print-scfg wrapper container">
        {props.currentView == "CONFIGURE" ? <Configure /> : <BillofMaterials />}
      </div>
      <div style={{ display: "none" }}>
        <form
          id="contact"
          action="https://go.pardot.com/l/64562/2019-07-10/d37236"
        >
          <input name="email" value={props.pii.email} />
        </form>
      </div>
    </ThemeProvider>
  );
}

const theme = createMuiTheme({
  palette: {
    primary: { main: "#005596" },
    secondary: { main: "#FFC000" },
    contrastThreshold: 3
  },
  typography: {
    htmlFontSize: 10,
    fontSize: 14,
    body1: {
      fontSize: "18px",
      color: "#010304"
    },
    body2: {
      fontSize: "18px",
      color: "#010304",
      fontWeight: 700
    },
    h3: {
      fontWeight: 300
    },
    h6: {
      fontWeight: 400,
      color: "#010304"
    }
  },
  overrides: {
    MuiDialogTitle: {
      root: {
        backgroundColor: "#4383C3",
        color: "white",
        fontSize: 18
      }
    },
    MuiDialogActions: {
      root: {
        backgroundColor: "#EAEAEA",
        padding: 20
      }
    },
    MuiRadio: {
      root: {}
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 14
      }
    },
    MuiStepLabel: {
      label: {
        fontSize: 18,
        fontFamily: "robotolight",
        color: "#9E9E9E"
      },
      completed: {
        color: "#005596",
        cursor: 'pointer'
      },
      active: {
        color: "#005596"
      }
    },
    MuiButton: {
      contained: {
        boxShadow: "none",
        borderRadius: 0
      },
      containedSecondary: {
        color: "#005596"
      }
    },
    MuiSlider: {
      root: {
        width: "95%",
        margin: "0 auto",
        display: "block"
      },
      markLabel: {
        fontSize: 11,
        color: "#b7b7b7"
      },
      markLabelActive: {
        fontSize: 11,
        color: "#b7b7b7"
      }
    },
    MuiListItemText: {
      root: {
        fontSize: 11
      }
    },
    MuiSelect: {
      root: {
        padding: "25px 10px 5px 10px",
        fontSize: 14
      }
    }
  }
});

const mapStateToProps = state => ({
  configuration: state.configuration,
  currentView: state.currentView,
  pii: state.pii
});

const mapDispatchToProps = dispatch => ({
  localeSettings: () => dispatch(ACTIONS.localeSettings())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
  )(App);
// export default App;
